import { Undo } from '@mui/icons-material';
import { Button } from '@mui/material';
import { MouseEvent } from 'react';
import { OrgTypeWithRole } from 'src/@types/org';
import { InviteStatus } from 'src/@types/userOrg';
import { useUpdateCurrentUserOrgStatus } from 'src/hooks/query/userHooks';
import OrgSwitcherRowBase from './OrgSwitcherRowBase';

type RejectedOrgInviteRowProps = {
  org: OrgTypeWithRole;
  onInviteStatusUpdated: () => void;
};

export default function RejectedOrgInviteRow({
  org,
  onInviteStatusUpdated,
}: RejectedOrgInviteRowProps) {
  const { mutate: updateCurrentUserOrgStatus, isPending } = useUpdateCurrentUserOrgStatus(
    org.id || ''
  );

  const handleUndoRejection = () => {
    if (!org.id) return;

    updateCurrentUserOrgStatus(
      { data: { invite_status: InviteStatus.Pending } },
      {
        onSuccess: () => {
          onInviteStatusUpdated();
        },
      }
    );
  };

  const handleUndoButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    handleUndoRejection();
  };

  return (
    <OrgSwitcherRowBase
      org={org}
      actions={
        <Button
          variant="text"
          color="primary"
          startIcon={<Undo />}
          onClick={handleUndoButtonClick}
          disabled={!org.id}
          loading={isPending}
          sx={{ borderRadius: 999 }}
        >
          Undo
        </Button>
      }
    />
  );
}
